/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * TSOA-friendly forced-user assignment strategy used by the MeLi sync endpoint.
 */
export type MeliItemSyncImportAssignmentForceUser = {
    /**
     * Assignment mode.
     */
    mode: MeliItemSyncImportAssignmentForceUser.mode;
    /**
     * User id to assign when `mode=forceUser`.
     */
    userId: number;
};
export namespace MeliItemSyncImportAssignmentForceUser {
    /**
     * Assignment mode.
     */
    export enum mode {
        FORCE_USER = 'forceUser',
    }
}

